<template>
	<div class="relative bg-wrap-color" v-loading="mixinLoading">

		<template v-if="isPageAllowed">
            <div class="tab-bar relative" v-if="componentName == 'ListPage' ">
                <el-tabs value="batch" >
                  <el-tab-pane label="批量创建" name="batch"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="bg-color list-wrap">
                <keep-alive :include="aliveList">
                    <component
                        :ref="componentName"
                        :is="componentName"
						:pageFuncNames="pageFuncNames"
                        :pageDimensionNames="pageDimensionNames"
                        :pageParams="pageParams"
						@to-page="handleToPage"
                    />
                </keep-alive>
            </div>

        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面展示ADS媒体相关数据内容与广告管理。</p>
            </NoPermissionInfo>
        </template>
	</div>
  
</template>

<script>
import ConfigPage from './page/configPage/index.vue'
import ListPage from '../configuration/page/listPage.vue'
import InfoPage from '../configuration/page/infoPage.vue'
import PreviewPage from '../configuration/page/previewPage.vue'
import NoPermissionInfo from '@/components/noPermissionInfo';
import { pageMixin } from '@/views/mixins/pageMixin.js'
export default {
	mixins: [pageMixin],
	components: {
		ConfigPage,
		ListPage,
		InfoPage,
		PreviewPage,
		NoPermissionInfo
	},
	data() {
		return {
			componentName: 'ListPage',
			pageParams: { id: 510 }, // 页面参数
			aliveList: [ 'ListPage' ], // 缓存组件列表
		}
	},
	methods: {
		handleToPage(name, data, refresh = false) {
			if (refresh) {
				_.remove(this.aliveList, (item) => {
					return item == name;
				});
				this.$nextTick(() => {
					this.aliveList.push(name);
				})
			};
			this.componentName = name;
			console.log(name, data);
			this.pageParams = data;
		}
	}
}
</script>

<style lang="scss" scoped>
.tab-bar::after{
	content: '';
	position: absolute;
	left: -20px;
	right: -20px;
	background-color: #fff;
}
.tab-bar ::v-deep .el-tabs__header{
	background-color: #fff;
	margin-bottom: 10px;
	.el-tabs__nav-wrap{
		padding-left: 30px;
	}
}
    .tab-bar ::v-deep .el-tab-pane{
        margin: 0 15px;
    }
.bg-wrap-color{
	padding: 0;
	background-color:#F1F4F9;
}
.list-wrap{
	margin: 0 10px;
	min-height: 100vh;
}
</style>